export default __webpack_public_path__ + "static/how-it-works-2-67e3bc2686daec966158f72e3ce1a9fe.png";